define([
	"dojo/_base/declare",
	"csi/table/New",
	"./_NewStyleMixin"
], function(declare, New, _NewStyleMixin) {

	return declare([New, _NewStyleMixin], {
	});
});